<template>
  <div class="ArtistSocialStats">{{ artist.followers }} | {{ artist.views }}</div>
</template>

<script>
export default {
  name: "ArtistSocialStats",
  props: ["artist"],
}
</script>
